/*
* Цвета события в сетке календаря
*
* По макету событие выглядит как tonal-чип: подложка того же цвета с низкой
* прозрачностью и насыщенный текст. FullCalendar принимает только готовые
* значения, поэтому подложку считаем здесь.
*/

const parseHex = (hex: string): [number, number, number] | null => {
  const value = hex.replace('#', '')

  const full = value.length === 3
    ? value.split('').map(char => char + char).join('')
    : value

  if (full.length !== 6) return null

  const int = Number.parseInt(full, 16)

  if (Number.isNaN(int)) return null

  return [(int >> 16) & 255, (int >> 8) & 255, int & 255]
}

export const getCalendarEventColors = (color: string) => {
  const rgb = parseHex(color)

  return {
    backgroundColor: rgb ? `rgba(${rgb.join(', ')}, 0.16)` : color,
    borderColor: 'transparent',
    textColor: color,
  }
}
